import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class PaginaApi {
    
    static getInfo(paginaInfo, token) {
        
       let paginaInfoEnvio = Object.assign({}, paginaInfo);
		let comando="POST";
		 
		paginaInfoEnvio=JSON.stringify(paginaInfoEnvio);
		return $.ajax({
			url: getLocacion()+ "/api/pagina/",
            headers: {"Authorization": "Bearer " + token.idToken},
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: paginaInfoEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}   
}